import { render, staticRenderFns } from "./QA_bd.vue?vue&type=template&id=3cf8f7ee&scoped=true&"
import script from "./QA_bd.vue?vue&type=script&lang=js&"
export * from "./QA_bd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf8f7ee",
  null
  
)

export default component.exports